import { useState, useEffect } from "react";
import DistributorNavbar from "./DistributorComp/DistributorNavbar";
import DataTable from "react-data-table-component";
import axios from "axios";
import { baseurl } from "../../component/Baseurl";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import { Link } from "react-router-dom";

function PinRequestByAgent() {
  const [filterText, setFilterText] = useState("");
  const [pinRequests, setPinRequests] = useState([]);
  const [availablePins, setAvailablePins] = useState(0);
  const distributorId = localStorage.getItem("distributor_id");

  useEffect(() => {
    const fetchPinRequests = async () => {
      try {
        const response = await axios.get(`${baseurl}AllPinRequestsForDistributor/${distributorId}`);
        setPinRequests(response.data.data || []);
        setAvailablePins(parseInt(response.data.available_pins) || 0);
      } catch (error) {
        console.error("Error fetching pin requests:", error);
        setPinRequests([]);
      }
    };

    fetchPinRequests();
  }, [distributorId]);

  // Handle Grant Request action
  const handleGrantRequest = async (requestId, totalAmount) => {
    if (availablePins >= totalAmount) {
      try {
        // ✅ Log the data being sent
        console.log("Granting Request - Data Sent:", {
          requestId,
          distributorId
        });
  
        const response = await axios.post(`${baseurl}GrantPinRequest`, {
          requestId,
          distributorId
        });
  
        // ✅ Log the API response
        console.log("API Response:", response.data);
  
        if (response.data.success) {
          Swal.fire("Success", "Request granted successfully!", "success");
          setAvailablePins(availablePins - totalAmount);
        } else {
          Swal.fire("Error", "Failed to grant request.", "error");
        }
      } catch (error) {
        console.error("Error during request:", error);
        Swal.fire("Error", "Something went wrong.", "error");
      }
    } else {
      Swal.fire("Insufficient Pins", "Please add more pins.", "warning");
    }
  };
  

  // Columns for the DataTable
  const columns = [
    { name: "Sr. No.", selector: (row, index) => index + 1, sortable: false, width: "80px" },
    { name: "Agent ID", selector: (row) => row.user_id, sortable: true },
    { name: "Pin Quantity", selector: (row) => row.pin_qty, sortable: true },
    { name: "Cost per Pin", selector: (row) => `₹${row.cost_per_pin}`, sortable: true },
    { name: "Total Amount", selector: (row) => `₹${row.total_amount}`, sortable: true },
    { name: "Status", selector: (row) => row.status, sortable: true },
    { name: "Date", selector: (row) => new Date(row.created_at).toLocaleDateString(), sortable: true },
    {
      name: "Grant Request",
      cell: (row) =>
        availablePins >= row.pin_qty ? ( // ✅ Compare `pin_qty` with `availablePins`
          <button
            className="btn3 btn-success text-white"
            onClick={() => handleGrantRequest(row.id, row.pin_qty)}
          >
            Grant Request
          </button>
        ) : (
          <Link to="/state-head/my-wallet" className="btn3 btn-warning text-white">
            Add Pins
          </Link>
        ),
      width: "180px",
    },
  ];
  

  const filteredRequests = pinRequests.filter(
    (request) =>
      request.status.toLowerCase().includes(filterText.toLowerCase())
  );

  // Function to Export DataTable as Excel
  const handleDownloadExcel = () => {
    const ws = XLSX.utils.json_to_sheet(pinRequests.map((row, index) => ({
      "Sr. No.": index + 1,
      "Agent ID": row.user_id,
      "Pin Quantity": row.pin_qty,
      "Cost per Pin": row.cost_per_pin,
      "Total Amount": row.total_amount,
      "Status": row.status,
      "Date": new Date(row.created_at).toLocaleDateString(),
    })));

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Pin Requests");
    XLSX.writeFile(wb, "Pin_Requests.xlsx");
  };

  return (
    <>
      <DistributorNavbar />
      <div className="bgagent transaction-container">
        <div className="container-fluid">
          <div className="row g-2 mb-3">
            <div className="col-md-3">
              <div className="bg-white p-3 border rounded">
                <h2 className="title text-start">Available Pins</h2>
                <div className="kma2 text-start">{availablePins}</div>
              </div>
            </div>
          </div>

          <div className="crdmain">
            <div className="transaction-card">
              <h2 className="title text-start">Pending Pin Requests</h2>

              <input
                type="text"
                className="search-box"
                placeholder="Search requests..."
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
              />

              <DataTable
                columns={columns}
                data={filteredRequests}
                pagination
                highlightOnHover
                striped
                noDataComponent="No requests found"
                className="transaction-table"
              />

              <button className="btn btn-primary mt-3" onClick={handleDownloadExcel}>
                📥 Download Excel
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PinRequestByAgent;
